import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useEffect, useRef } from "react";

const RadioGroupFrom = ({ id, multiple, options, form, label }) => {
  return (
    <FormControl
      component="fieldset"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "20px",
      }}
    >
      <h4 className="font-[600] text-[#101828] text-base">{label}</h4>
      <RadioGroup
        aria-label={`private-fund-${id}`}
        name={`private-fund-${id}`}
        id={id}
        value={form.values[id]}
        style={{
          fontWeight: 500,
          fontSize: 14,
          display: "flex",
          flexDirection: "row",
        }}
        onChange={(e) => {
          form.setFieldValue(id, e.target.value);
        }}
      >
        {options?.map((item, index) => (
          <FormControlLabel
            key={index}
            value={item}
            control={
              <Radio
                sx={{
                  color: "#159AA8",
                  "&.Mui-checked": {
                    color: "#159AA8",
                  },
                }}
              />
            }
            label={item}
          />
        ))}
      </RadioGroup>
      {form?.errors[id] && (
        <div className="text-red-500 font-Source-Sans-Pro text-xs mt-[2px] ml-1">
          {form?.errors[id]}
        </div>
      )}
    </FormControl>
  );
};

export default RadioGroupFrom;
